exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4{font-weight:700;font-size:30px}.timeRangeDropdown{color:#000}", ""]);

// exports
